const { Modal } = require("antd");

export const ModalInformativo = (titulo = 'Aviso', mensagem = '') => {
    Modal.info({
        title: titulo,
        content: mensagem,
        centered: true,
        width: 600
    });
};
